<template>
  <div>
    <div class="resize-box absolute-fill" v-bind:class="{ 'as-override': !isPrimary }" />
    <template v-if="canTransform">
      <div
        v-if="blob.type != 'BTN'"
        v-for="[x, y] in [ [-1, -1], [1, -1], [1, 1], [-1, 1] ]" :key="`${x}${y}`"
        class="corner-btn"
        v-bind:style="{
          left: x < 0 ? - btnOffset + 'px' : undefined,
          right: x > 0 ? - btnOffset + 'px' : undefined,
          top: y < 0 ? - btnOffset + 'px' : undefined,
          bottom: y > 0 ? - btnOffset + 'px' : undefined
        }"
        @mousedown="e => $emit('resize', e)"
        @touchstart="e => $emit('resize', e)"
      >
        <!-- We want the buttons to look small, but still be usable on mobile, so we use the containing div as an invisible background "button" -->
        <v-btn class="ma-3" v-blur fab x-small absolute color="red" :disabled="isShowingVirtualKeyboard" />
      </div>
      <div
        style="position: absolute; left: calc(50% - 52px); bottom: -120px; padding: 24px; pointer-events: auto;"
        @mousedown="e => $emit('rotate', e)"
        @touchstart="e => $emit('rotate', e)"
      >
        <tooltip-btn msg="Drag to rotate" top v-slot="{ on }">
          <v-btn v-blur v-on="on" fab color="red" :disabled="isShowingVirtualKeyboard">
            <v-icon color="white" v-html="mdiRotateRight" />
          </v-btn>
        </tooltip-btn>
      </div>
      <tooltip-btn
        v-if="!blob.btn?.form && (![ 'GIFTCARD', 'GROUP_VIDEO' ].includes(blob.type) || mode == 'purchase' || blob.sample)"
        msg="Delete" bottom
        v-slot="{ on }"
      >
        <v-btn
          v-blur v-on="on"
          style="left: calc(50% - 28px); top: -96px; pointer-events: auto;"
          fab absolute color="red"
          @click.stop="$emit('delete')"
        >
          <v-icon color="white" v-html="mdiDelete" />
        </v-btn>
      </tooltip-btn>
    </template>
  </div>
</template>


<style scoped>
.resize-box {
  outline: 4px dashed red;
  box-shadow:
    inset 0 0 8px 8px rgba(255, 255, 255, .2),
    0 0 8px 8px rgba(255, 255, 255, .2);
}
.resize-box.as-override {
  /* This color matches the Vuetify 'blue' (which is probably available as an scss variable somewhere...) */
  outline: 4px dashed rgb(33,150,243);
}
.corner-btn {
  position: absolute;
  width: 56px;
  height: 56px;
  pointer-events: auto;
}
</style>


<script>
import { mdiRotateRight, mdiDelete } from '@mdi/js';


export default {
  name: 'blob-selection-controls',

  props: [ 'blob', 'canTransform', 'isPrimary', 'mode', 'isShowingVirtualKeyboard' ],

  created() {
    Object.assign(this, { btnOffset: 30, mdiRotateRight, mdiDelete });
  }
}
</script>
